module.exports = __webpack_public_path__ + "static/media/Fantom of the Opera.3b781b9e.png";